import { Carcass, DoorFronts } from '../parts/storage'
import { Printer } from '../parts/tech'
import type { AssetContext, AssetDefinition } from '../types'

/** Stand dimensions — kept under the printer so it overhangs on every side. */
const STAND_WIDTH = 0.46
const STAND_DEPTH = 0.42
const STAND_HEIGHT = 0.6
/** The printer sinks 2 mm into the stand top so no two faces end up coplanar. */
const STAND_SEAT = STAND_HEIGHT - 0.002

/**
 * Two-door cabinet the printer sits on. Local to this asset — the accent stays
 * on the printer itself, so the doors are plain shell.
 */
function PrinterStand() {
  const plinth = 0.05
  const doorHeight = STAND_HEIGHT - plinth - 0.03
  return (
    <group>
      <Carcass width={STAND_WIDTH} depth={STAND_DEPTH} height={STAND_HEIGHT} plinth={plinth} />
      <DoorFronts
        width={STAND_WIDTH - 0.01}
        height={doorHeight}
        y={plinth + doorHeight / 2 + 0.01}
        depth={STAND_DEPTH}
        count={2}
        handle="bar"
      />
    </group>
  )
}

/**
 * Multifunction printer, either straight on a surface or on its own cabinet.
 * Origin at the centre of the footprint, y = 0 at the floor (or at the tabletop
 * for the desktop variant), output tray facing +Z.
 */
function PrinterAsset({ accent, variant = 'sobremesa' }: AssetContext) {
  const onStand = variant === 'pedestal'
  return (
    <group>
      {onStand ? <PrinterStand /> : null}
      <Printer accent={accent} base={onStand ? STAND_SEAT : 0} />
    </group>
  )
}

export const definition: AssetDefinition = {
  id: 'printer',
  name: 'Impresora',
  category: 'tech',
  footprint: [0.52, 0.47],
  // Tallest variant: cabinet + printer body.
  height: 0.96,
  stackable: true,
  accentable: true,
  variants: [
    { id: 'sobremesa', name: 'Sobremesa' },
    { id: 'pedestal', name: 'Con pedestal' },
  ],
  keywords: ['impresora', 'multifuncion', 'multifunción', 'printer', 'escaner', 'scanner', 'copiadora'],
  Component: PrinterAsset,
}
